Object.defineProperty(exports,"__esModule",{value:true});exports.getSecurityDevicePortsState=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};

var _types=require('./types');
var _types2=require('../complianceState/types');





var getSecurityDevicePortsState=exports.getSecurityDevicePortsState=function getSecurityDevicePortsState(
originalDevice,
colors,
session)
{
if(!originalDevice){
return null;
}var

ports=originalDevice.ports;
if(!ports){
return null;
}

if(originalDevice.deviceType===_types.DeviceType.SECURE_PLUG){
return ports.map(function(port){
if(!port)return null;
var color=colors.gray;
if(port.socketFault){
color=colors.red;
}else if(port.devicePluggedIn&&port.calibrated){
color=colors.green;
}else if(port.devicePluggedIn&&!port.calibrated){
color=colors.yellow;
}
return _extends({},port,{color:color});
});
}else if(originalDevice.deviceType===_types.DeviceType.CX_FLEX_FOUR_PORT){
var portsDetail=originalDevice.unhealthyDetail;
var unhealthyPorts=void 0;
var NO_CABLE=0;

if(portsDetail){

unhealthyPorts=portsDetail.match(/\d+/g).map(Number);
}


var portRuleTypes=['port_products','port_live_products'];
var nonCompliantRules=[];
var positionRules=originalDevice.positionId.ruleIds.toRefArray();
for(i=0;i<positionRules.length;i++){
rule=positionRules[i];
if(
portRuleTypes.includes(rule.sourceAttribute)&&
rule.status===_types2.PositionRuleStatus.VIOLATION)
{
nonCompliantRules.push(rule);
}
}


var portRuleParameters=nonCompliantRules.map(function(rule){return rule.parameter;});
var nonCompliantPorts=portRuleParameters.map(function(param){return(
Object.keys(param));});

nonCompliantPorts=nonCompliantPorts.map(function(portNumber){return(
parseInt(portNumber,10));});


return ports.map(function(port){
if(!port)return null;

var unhealthy=unhealthyPorts&&unhealthyPorts.includes(port.address);
var nonCompliant=
nonCompliantPorts&&nonCompliantPorts.includes(port.address);

var color=colors.green;
if(port.primaryDeviceAlarming||port.secondaryDeviceAlarming){
color=colors.red;
}else if(unhealthy||nonCompliant){
color=colors.yellow;
}else if(port.cableType==NO_CABLE){
color=colors.gray;
}
return _extends({},port,{color:color});
});
}else{
return ports;
}
};